import { Toolbar, Item, DataGridRef } from "devextreme-react/data-grid";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { SystemUsersDS } from "../../dataSources/SystemUsersDS";
import { openPopup } from "../../helper/DxHelper";
import { basicSettings } from "../../helper/GridCreator/gridConfig";
import GridCreator from "../../helper/GridCreator/GridCreator";
import { userActions } from "../../redux/user/user-slice";
import { GridType, User } from "@/types/types";
import Update from "./Update";
import Insert from "./Insert";
import { householdActions } from "@/redux/household/household-slice";
import { PopupRef } from "devextreme-react/cjs/popup";
import { ColumnCellTemplateData } from "devextreme/ui/data_grid";
import { useAppSelector } from "@/hooks/useAppSelector";

export default function SystemUsers() {
  const { user } = useAppSelector((state) => state.system);
  const datagridRef = useRef<DataGridRef>(null);
  const insertPopupRef = useRef<PopupRef>(null);
  const updatePopupRef = useRef<PopupRef>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(householdActions.setHeader({ title: "Users", content: "" }));

    return () => {
      dispatch(householdActions.setHeader({ title: "", content: "" }));
    };
  }, [dispatch]);

  const addButtonOptions = {
    icon: "plus",
    onClick: () => {
      openPopup(insertPopupRef);
    },
  };

  function renderToolbar() {
    return (
      <Toolbar>
        <Item
          location="after"
          locateInMenu={"auto"}
          widget="dxButton"
          options={addButtonOptions}
          cssClass="dx-datagrid-insert-button"
        />
        <Item name="columnChooserButton" location="after" />
        <Item name="searchPanel" location="after" />
      </Toolbar>
    );
  }

  const gridSettings: GridType<User, string> = {
    ...basicSettings,
    ref: datagridRef,
    id: "suGrid",
    dataSource: SystemUsersDS(),
    toolbar: renderToolbar,
    columns: [
      {
        key: "cmd",
        width: 90,
        cellRender: cmdCellRender,
        allowExporting: false,
        allowHiding: false,
        allowResizing: false,
        showInColumnChooser: false,
      },
      {
        key: "userId",
        dataField: "id",
        visible: false,
        allowEditing: false,
      },
      {
        key: "firstNameKey",
        dataType: "string",
        dataField: "firstName",
        visible: true,
        allowEditing: false,
      },
      {
        key: "lastNameKey",
        dataField: "lastName",
        dataType: "string",
        visible: true,
        allowEditing: false,
        hidingPriority: 4,
      },
      {
        key: "emailKey",
        dataField: "email",
        dataType: "string",
        visible: true,
        allowEditing: false,
        hidingPriority: 5,
      },
      {
        key: "usernameKey",
        dataField: "username",
        dataType: "string",
        visible: true,
        allowEditing: false,
        hidingPriority: 5,
      },
      {
        key: "inactive",
        dataField: "inactive",
        dataType: "boolean",
        visible: true,
        allowEditing: false,
        hidingPriority: 5,
      },
    ],
  };

  function cmdCellRender(e: ColumnCellTemplateData<User>) {
    return (
      <div className="flex items-center">
        <button
          title="edit"
          onClick={() => {
            openPopup(updatePopupRef);
            dispatch(
              userActions.setEditUserData({
                id: e.row.data.id,
                name: `${e.row.data.firstName} ${e.row.data.lastName}`,
              })
            );
          }}
        >
          <img src="/icons/edit-icon.svg" />
        </button>
      </div>
    );
  }

  return (
    <>
      {user?.isAdmin ? (
        <>
          <Update popupRef={updatePopupRef} datagridRef={datagridRef} />
          <Insert popupRef={insertPopupRef} datagridRef={datagridRef} />
          <GridCreator {...gridSettings} />
        </>
      ) : null}
    </>
  );
}
